'use client';

import { Suspense } from 'react';

import Footer from '@/components/Footer';
import Header from '@/components/Header';
import '@/styles/headerfooter.css';
import ZapChat from '@/components/ZapChat';

export default function SubscriptionPage() {
  return (
    <>
      <ZapChat />
      <main id="main-content" className="min-h-screen">
        <Suspense
          fallback={
            <div className="fixed top-0 right-0 left-0 z-50 h-[72px] border-black/5 border-b bg-white shadow-sm" />
          }
        >
          <Header />
        </Suspense>

        {/* Subscription Terms Section */}
        <section className="subscription-page">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Subscription Terms</h2>
            </div>

            <div className="subscription-content">
              <section className="subscription-section">
                <h3 className="text-gray-950">1. Overview</h3>
                <p>
                  This agreement sets out the terms under which ZappingAI will provide automation
                  and AI consulting services to the client.
                </p>
                <p>
                  The aim is to ensure clear expectations, transparent pricing, and a smooth working
                  relationship.
                </p>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">2. Fees and Payment</h3>
                <p>
                  All fees will be agreed in writing (by email, proposal, or invoice) before work
                  begins.
                </p>
                <p>Payment is made via Stripe using the link provided, unless otherwise agreed.</p>
                <p>Payment must be received before work commences.</p>
                <p>All prices are subject to VAT where applicable.</p>
                <p>
                  Where a monthly retainer is in place, it operates under a 12-month rolling
                  contract and renews automatically each year unless cancelled in writing with 30
                  days&apos; notice before the renewal date.
                </p>
                <p>Monthly retainers are billed automatically via Stripe on the agreed schedule.</p>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">3. Delivery and Timelines</h3>
                <p>Delivery dates and milestones will be confirmed once payment is received.</p>
                <p>
                  ZappingAI will make every reasonable effort to deliver work on time and will
                  communicate promptly if delays occur.
                </p>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">4. Client Responsibilities</h3>
                <p>The client agrees to:</p>
                <ul className="subscription-list">
                  <li>
                    Provide the necessary information, access, and feedback required to complete the
                    work.
                  </li>
                  <li>Ensure that any data shared is accurate and authorised for use.</li>
                </ul>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">5. Hosting, Support and Maintenance</h3>
                <p>Ongoing support retainer covers:</p>
                <ul className="subscription-list">
                  <li>Workflow Hosting and Integration</li>
                  <li>Monitoring of existing automations or integrations.</li>
                  <li>Maintenance & Minor updates and adjustments.</li>
                  <li>Quick fixes in the event of third-party system changes.</li>
                </ul>
                <p>Significant new functionality or system builds will be quoted separately.</p>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">6. Confidentiality</h3>
                <p>
                  ZappingAI will keep all client information confidential and use it solely for the
                  purpose of delivering services.
                </p>
                <p>
                  No information will be shared with third parties without consent, except where
                  required by law.
                </p>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">7. Limitation of Liability</h3>
                <p>
                  ZappingAI will take all reasonable care to deliver reliable solutions but cannot
                  be held responsible for indirect losses, data loss, or business interruption
                  caused by third-party systems or circumstances beyond its control.
                </p>
                <p>
                  The client remains responsible for maintaining appropriate backups and system
                  access controls.
                </p>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">8. Termination</h3>
                <p>Either party may end this agreement with 30 days&apos; written notice.</p>
                <p>
                  For rolling contracts, termination must be given at least 30 days before the
                  annual renewal date to avoid automatic renewal.
                </p>
                <p>All fees for completed or in-progress work remain payable in full.</p>
              </section>

              <section className="subscription-section">
                <h3 className="text-gray-950">9. Acceptance</h3>
                <p>
                  By making payment through Stripe or confirming in writing, the client acknowledges
                  and agrees to these terms.
                </p>
              </section>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}
